import React from "react";
import ReactDOM from "react-dom";
import unsplash from "../api/unsplash";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../utils/index'
import '../style/style.scss';
import CIcon from '@coreui/icons-react';
import { cilSearch } from '@coreui/icons';
import { CSpinner } from "@coreui/react";

class CheckHomepage extends React.Component {      
  




    constructor (props)
    {
        super(props);

        this.state = {
            clienti: [],
            clientiVisibili :[],
            loaded:false,
        };
    }
    

     componentDidMount(){ //dopo che l'elemento si è caricato
      console.log(sessionStorage.getItem("jwt"));
        unsplash.post('clienti',
        {auth : "a5d42c3ed7977afa2d8e922569e7940b"},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }} )
    
        .then(res => {
            console.log(res.data);
            const clienti = res.data.data;
            this.setState({ clienti : clienti });
            this.setState({clientiVisibili : clienti})
            this.setState({loaded : true})
          })
        }

        handleClick = (e, data) => {
          // access to e.target here
          console.log(data);
          this.props.navigate('/copertinaCliente',{state:{idC: data.ID}})
          

      }

      handleChange = (e) => { // filtro
        console.log(e.target.value == "");
   
        if(e.target.value == ""){
          this.setState({clientiVisibili : this.state.clienti})
         
        }else{
          var clientiX = []; // popolo l'array 
        var i;
        for (i =0 ;i < this.state.clienti.length;i++){
          if (this.state.clienti[i].RagioneSociale.toLowerCase().includes((e.target.value.toLowerCase() ))){
            clientiX.push(this.state.clienti[i]);
          }
        }
  this.setState({clientiVisibili : clientiX})
        }
      }
  
     render() {
        return (
      
      <>
     
            <div  ><center >
              
            <div className="form-outline mb-4 input-group" style={{width:"33%"}}>
<span class="input-group-text bg-transparent">
            <i class="bi bi-search" ></i>
            </span>
  
            <input onChange={this.handleChange} className="form-control form-control-lg border-left-0"/>
           
          </div>
              
              </center></div>
            <table className="table table-hover ">
            <thead><tr><th scope="col"  style={{color:"white",textAlign:"center",backgroundColor:"#2264ae"}}>Clienti</th></tr></thead>
            <tbody>
        {
        
        this.state.clientiVisibili.length === 0 && !this.state.loaded ?(<p> <center><CSpinner color="primary"/></center></p>):(
        
        this.state.clientiVisibili?.map(cliente => <tr key={cliente.ID} style={{textAlign:"center",cursor:"pointer"}} ><td onClick={((e) => this.handleClick(e, cliente))}>{cliente.RagioneSociale}</td></tr>)
        )
        }
        </tbody>
      </table>
      </>
        )
     }



} 
function WithNavigate(props) {
  const navigate = useNavigate();

  return <CheckHomepage {...props} navigate={navigate} />;
}

export default WithNavigate

